/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: 59a99c5e (Wed Sep  2 22:08:21 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum PaymentMethodKey {
  Cc = 'CC',
  Ach = 'ACH',
  NA = 'N/A',
  Adj = 'ADJ',
}

export function PaymentMethodKeyFromJSON(json: any): PaymentMethodKey {
  return PaymentMethodKeyFromJSONTyped(json, false)
}

export function PaymentMethodKeyFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PaymentMethodKey {
  return json as PaymentMethodKey
}

export function PaymentMethodKeyToJSON(value?: PaymentMethodKey | null): any {
  return value as any
}
